import Vue from "vue";

const getDefaultState = () => {
  return {
    /** ===== USER DATA ===== */
    sessionCount: 0,

    /** ===== BOOKING RESTRICTION STATES ===== */
    bookingLimit: 2000, // set to max to let users without limits start booking before data is loaded, backend will catch it if they aren't supposed to
    bookedCount: 0,
    bookingSuspendedByAdmin: false,
    bookingSuspendedCancellationAbuse: false,
    bookingFrozen: false,
    sessionsUntilUnlimitedBooking: 0,

    /** ===== SUBSCRIPTION DATA ===== */
    nrOfUsedFreeSessions: 0,
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },
  updateBookingRestrictionData(data) {
    for (let key in data) {
      if (data[key] || data[key] === false || data[key] === 0) {
        /** if key exists in state, update the value */
        if (Object.hasOwn(state, key)) {
          state[key] = data[key];
        }
      }
    }
  },

  setNrOfUsedFreeSessions(nrOfUsedFreeSessions) {
    state.nrOfUsedFreeSessions = nrOfUsedFreeSessions;
  },

  addToBookedCount(nrToAdd) {
    state.bookedCount = state.bookedCount + nrToAdd;
  },

  subtractFromBookedCount(nrToSubtract) {
    state.bookedCount = state.bookedCount - nrToSubtract;
  },
};

const CalendarStore = {
  state,
  methods,
};
export default CalendarStore;
